/* unplugin-vue-components disabled */import { render } from "./ActPage2.vue?vue&type=template&id=379a03d8&scoped=true"
import script from "./ActPage2.vue?vue&type=script&lang=js"
export * from "./ActPage2.vue?vue&type=script&lang=js"

import "./ActPage2.vue?vue&type=style&index=0&id=379a03d8&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/txgynew-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-379a03d8"]])

export default __exports__